import ProfileMenu, { MenuItemsType } from './menu';

export { MenuItemsType };
export default ProfileMenu;
